"use client";
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <>
      {/* Full-width grey background */}
      <div
        className="w-full py-20 flex flex-col items-center text-center"
        style={{
          backgroundColor: "var(--nhs-pale-grey)",
          color: "var(--nhs-black)",
          minHeight: "60vh",
        }}
      >
        {/* Large NHS-style heading */}
        <h1
          className="text-6xl font-bold mb-4"
          style={{ color: "var(--nhs-dark-blue)" }}
        >
          404
        </h1>

        {/* Sub-heading */}
        <h2 className="text-3xl font-bold mb-4">Page not found</h2>

        {/* Message */}
        <p className="text-lg mb-8 max-w-2xl">
          We’re sorry — the page you are looking for cannot be found.
          <br />
          It may have been moved, deleted, or may never have existed.
        </p>

        {/* Return Button – NHS style */}
        <Link
          to="/"
          className="nhsuk-button"
          style={{
            backgroundColor: "var(--nhs-green)",
            border: "1px solid var(--nhs-black)",
            borderRadius: 0,
            color: "var(--nhs-white)",
            textDecoration: "none",
          }}
        >
          Return to homepage
        </Link>
      </div>
    </>
  );
}
